import React from 'react';
import disabled from '../../../images/disabled.png';
import disabled_gray from '../../../images/disabled_gray.png';
import disabled_pink from '../../../images/disabled_pink.png';
import { Modal } from 'antd';

class DisabledPopup extends React.Component {
  render() {
    const { color, t } = this.props;
    const styles = {
      title: {
        marginBottom: 10,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        textAlign: 'center',
        marginTop: 20
      },
      button: {
        margin: '0 auto',
        backgroundColor: color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: 200,
        textAlign: 'center',
        marginTop: 20,
        cursor: 'pointer',
        padding: 10,
        marginBottom: 20
      }
    };

    let image;
    if (color == '#F190AC') {
      image = disabled_pink;
    } else if (color == '#7c868d') {
      image = disabled_gray;
    } else {
      image = disabled;
    }

    return (
      <Modal
        footer={false}
        visible={this.props.open}
        onCancel={this.props.close}
        width={450}>
        <img
          src={image}
          style={{
            maxWidth: 150,
            margin: '0 auto',
            display: 'block',
            marginTop: 40
          }}
        />
        <h3 style={styles.title}>
          Oops! Looks like you have not completed your current phase.
        </h3>
        <div onClick={() => this.props.close()} style={styles.button}>
          Done
        </div>
      </Modal>
    );
  }
}

export default DisabledPopup;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/disabledPopup.js